import Lavender1 from '../Launching/Lavender (1).webp'
import Lavender2 from '../Launching/Lavender (2).webp'


const Lavenderimages =[
Lavender1,Lavender2
]

export default Lavenderimages;